class util{
	constructor(){
	}
	multiEventBind(target, events, callback){
		events.split(' ').forEach((event) => {
			target.addEventListener(event, callback);
		});
	}
}

window.app.add('util', new util());